import { theme } from "nectar-ui";
import { DASHBOARD_CHART_TYPES } from "@utils/constants/dashboard/dashboardModuleConstants";
import { apexChartInvertedSeriesClickHandler } from "@utils/helpers/dashboardHelpers";

import { getCalendarActivityColors } from "../helpers";
import { CalendarActivityTypes } from "@customTypes/filter";
import { ApexOptions } from "apexcharts";

export const MAXIMUM_RESPONSIBLE_NUMBER = 8;

export const getChartOptions = (
  responsible: string[],
  calendarActivityTypes: CalendarActivityTypes[]
): ApexOptions => ({
  chart: {
    id: DASHBOARD_CHART_TYPES.IN_PROGRESS_ACTIVITIES_BY_RESPONSIBLE.chart,
    type: "bar",
    fontFamily: theme.nectar.fontStack.default,
    stacked: true,
    toolbar: {
      show: false,
    },
    events: {
      legendClick: apexChartInvertedSeriesClickHandler,
    },
  },
  colors: getCalendarActivityColors(calendarActivityTypes),
  dataLabels: {
    style: {
      colors: [theme.nectar.colors.gray900],
    },
  },
  plotOptions: {
    bar: {
      horizontal: false,
      borderRadius: 4,
      borderRadiusWhenStacked: "last",
      borderRadiusApplication: "end",
      barHeight: "100%",
      dataLabels: {
        total: {
          enabled: true,
          style: {
            fontSize: "14px",
            color: theme.nectar.colors.gray900,
            fontWeight: 900,
          },
        },
      },
    },
  },
  stroke: {
    width: 1,
    colors: ["#fff"],
  },
  xaxis: {
    categories: responsible,
    labels: {
      rotate: 0,
      rotateAlways: false,
      trim: true,
      hideOverlappingLabels: false,
      style: {
        fontSize: "14px",
        fontWeight: 300,
        colors: theme.nectar.colors.gray500,
      },
    },
  },
  yaxis: {
    labels: {
      style: {
        fontSize: "14px",
        fontWeight: 300,
        colors: theme.nectar.colors.gray500,
      },
      formatter(value: number) {
        return Math.round(value).toString();
      },
    },
  },
  grid: {
    show: true,
    xaxis: {
      lines: {
        show: false,
      },
    },
    yaxis: {
      lines: {
        show: true,
      },
    },
  },
  fill: {
    opacity: 1,
  },
  legend: {
    position: "bottom",
    horizontalAlign: "center",
    offsetY: 8,
    itemMargin: {
      horizontal: 14,
    },
    onItemClick: {
      toggleDataSeries: false,
    },
  },
});
